import type { CheckboxElementValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'
import { textToRtValue } from '@vedalib/rich-text'
import { useState } from 'react'

import { DEMO_MODE } from 'services/Store/Project/constants'
import { t } from 'services/Translation'

import DemoWrapper from '../../decorators/DemoWrapper'
import Element from './CheckboxElement/CheckboxElement'
import type { CheckboxDemoType, CheckboxStateType } from './checkboxTypes'

const DEMO_VALUE: CheckboxElementValue = {
  items: [
    {
      label: textToRtValue(t('input.label.text')),
      value: 'id_checkbox_item_1',
    },
    {
      label: textToRtValue(t('input.label.text')),
      value: 'id_checkbox_item_2',
    },
    {
      label: textToRtValue(t('input.label.text')),
      value: 'id_checkbox_item_3',
    },
    {
      label: textToRtValue(t('input.label.text')),
      value: 'id_checkbox_item_4',
    },
  ],
  type: CONFIG_ELEMENTS.checkbox.defaultValue.type,
  condition: CONFIG_ELEMENTS.checkbox.defaultValue.condition,
}
const ITEMS = DEMO_VALUE.items.map((item, index) => ({
  ...item,
  disabled: index > 1,
  checked: index === 1 || index == 3,
}))

const CheckboxDemo: CheckboxDemoType = ({ styles, fonts, feedback }) => {
  const [state, setState] = useState<CheckboxStateType>({ items: ITEMS })
  return (
    <DemoWrapper center full>
      <Element
        element={{
          id: `${CONFIG_ELEMENTS.testMultipleChoice.type}-demo`,
          type: CONFIG_ELEMENTS.testMultipleChoice.type,
          value: DEMO_VALUE,
          font: {},
          style: {},
          feedback: {},
        }}
        feedback={feedback}
        font={fonts}
        mode={DEMO_MODE}
        setState={setState}
        state={state}
        styles={styles}
      />
    </DemoWrapper>
  )
}

export default CheckboxDemo
